import { Formatter } from '@ravago/shared/translations';

import { DayOfWeek, LocalDate, LocalDateTime, LocalTime, Period, TemporalAdjusters, ZoneOffset } from '@js-joda/core';

import { CallOffPeriod, DeliveryDate } from '../../models/elements';

export class DateUtils {
  static transformOrderDeliveryDate(formatter: Formatter, date: DeliveryDate) {
    const { from, until, type } = date;
    if (!from && !until) return undefined;

    if (type === 'ESTIMATED' && (until === undefined || until === null || from === until)) {
      return formatter.dateTime(from);
    }
    if (type === 'ESTIMATED' && from && until) {
      return `${formatter.dateTime(from)} - ${formatter.dateTime(until)}`;
    }
    if (until) {
      return formatter.dateTime(until);
    }
    return from ? formatter.dateTime(from) : undefined;
  }

  static transformCallOffOrderPeriod(formatter: Formatter, date: CallOffPeriod) {
    const { from, until } = date;
    if (from === undefined) return '-';

    if (until === undefined || until === null || from === until) return formatter.dateTime(from);
    return `${formatter.dateTime(from)} - ${formatter.dateTime(until)}`;
  }

  static getNextBusinessDay(start: LocalDateTime = LocalDateTime.now(), days = 2, cutOffHour = 16) {
    const cutOffTime = this.getCutOffTime(start, cutOffHour);
    const currentTime = start;

    if (currentTime.isAfter(cutOffTime)) {
      start = start.plusDays(1);
    }

    if (this.isWeekendDay(start)) {
      start = start.with(TemporalAdjusters.next(DayOfWeek.MONDAY));
    }

    const nextDate = this.addBusinessDays(start, days);
    return nextDate.toLocalDate().toString();
  }

  static getCutOffTime(start: LocalDateTime, cutOffHour: number): LocalDateTime {
    return LocalTime.of(cutOffHour).atDate(start.toLocalDate());
  }

  static isWeekendDay(date: LocalDateTime): boolean {
    return date.dayOfWeek() === DayOfWeek.SATURDAY || date.dayOfWeek() === DayOfWeek.SUNDAY;
  }

  static addBusinessDays(date: LocalDateTime, days: number): LocalDateTime {
    let result = date;
    let addedDays = 0;

    while (addedDays < days) {
      result = result.plusDays(1);
      if (!this.isWeekendDay(result)) {
        addedDays += 1;
      }
    }
    return result;
  }

  static getStartOfYearFromCurrentInUtc(minus: number): LocalDate {
    const currentDate = LocalDateTime.now(ZoneOffset.UTC);
    const beforeDate = currentDate.minus(Period.ofYears(minus));
    return LocalDate.of(beforeDate.year(), 1, 1);
  }
}
